import React, { useState } from "react";
import { MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown, MenuProps } from "antd";
import { observer } from "mobx-react-lite";
import { ZChildEntities } from "src/common/attrEdit/components/ZChildEntities";
import { ItemType } from "antd/es/menu/hooks/useItems";
import { ChangeStateBulkButton } from "src/pages/EntityFiltersPage/EntityList/ChangeStateBulkButton";
import { onError } from "src/common/onError";
import { ChildEntitiesStore } from "../ChildEntitiesStore";
import { CopyIn } from "./CopyIn";
import { ChildEntsActionType } from "../ChildEntities.types";
import { CopyFromV2 } from "./CopyFromV2";
import styles from "./ChildEntitiesActions.module.less";

interface PropsChildEntitiesActions {
  store: ChildEntitiesStore;
  disabled?: boolean;
  editorInfo?: ZChildEntities;
}

export const ChildEntitiesActions: React.FC<PropsChildEntitiesActions> =
  observer(
    ({
      store: { tableStore, avalibleActionsSet, currObjName, attrsMap, info },
      disabled,
      editorInfo,
    }) => {
      if (!info || !tableStore) return null;
      const { objectId, parentEntityId } = info;
      const [loading, setLoading] = useState<boolean>(false);

      const actionsMap: Partial<Record<ChildEntsActionType, ItemType>> = {
        [ChildEntsActionType.changeState]: {
          key: "stateChange",
          label: (
            <ChangeStateBulkButton
              tableStore={tableStore}
              objectId={objectId}
              onLoad={setLoading}
              attributes={Object.values(attrsMap)}
            />
          ),
        },
        [ChildEntsActionType.copyIn]: {
          key: "copyIn",
          label: (
            <CopyIn
              tableStore={tableStore}
              entityId={parentEntityId}
              onLoad={setLoading}
              parentObjId={objectId}
            />
          ),
        },
        [ChildEntsActionType.copyFrom]: {
          key: "copyFrom",
          label: (
            <CopyFromV2
              entityId={parentEntityId}
              parentObject={{ id: objectId, name: currObjName }}
              editorInfo={editorInfo}
              onFinish={() => {
                tableStore.reload().catch(onError);
              }}
            />
          ),
        },
      };

      const menuItems = Object.entries(actionsMap)
        .filter(([key]) => avalibleActionsSet.has(key as ChildEntsActionType))

        .map(([_key, item]) => [item, { type: "divider" } as ItemType])
        .flat();
      menuItems.pop();
      if (!menuItems.length) return null;
      const menuProps: MenuProps = { items: menuItems };

      return (
        <Dropdown menu={menuProps} placement="bottomRight" disabled={disabled}>
          <Button
            id="entityListActions"
            icon={<MoreOutlined className={styles.icon} />}
            loading={loading}
            className={styles.menuButton}
          />
        </Dropdown>
      );
    },
  );
